import PawnDetails from "./PawnDetails";

export default PawnDetails;
